var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconProfilePlaying = function SvgIconProfilePlaying(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 18.86V5.909a8.71 8.71 0 0 1 8.361.82l.139.095V19.61a10.057 10.057 0 0 0-8.5-.75ZM12 21.654a.838.838 0 0 1-.582-.144l-.38-.26a8.556 8.556 0 0 0-8.577-.64.843.843 0 0 1-1.211-.759V5.488c0-.324.185-.619.476-.76a10.21 10.21 0 0 1 10.234.764l.04.027.04-.027a10.21 10.21 0 0 1 10.234-.764c.291.141.476.436.476.76V19.85a.843.843 0 0 1-1.211.759 8.556 8.556 0 0 0-8.577.64l-.38.26a.838.838 0 0 1-.582.144Zm.75-2.044a10.057 10.057 0 0 1 8.5-.75V5.909a8.71 8.71 0 0 0-8.361.82l-.139.095V19.61Z",
    fill: "#000",
    fillOpacity: 0.5
  })));
};
export default SvgIconProfilePlaying;